module.exports = __webpack_public_path__ + "static/media/revenue-graph-monochrome.419ada0e.svg";